function cssLoaded(callback) {
    callback();
}
